import media from '@/styles/media';
import theme from '@/styles/theme';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from { transform: translate(-50%, -50%) rotate(0); }
  to { transform: translate(-50%, -50%) rotate(720deg); }
`;

export const AuthButton = styled.button`
  border: none;
  height: 50px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: ${theme.fontFamily.regular};
  color: ${theme.color.white};
  background-color: #4b586a;
  border-radius: 8px;
  cursor: pointer;
  transition: .1s;
  position: relative;

  ::after {
    content: '';
    display: none;
    position: absolute;
    width: 25px;
    height: 25px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: 1.4s ease-in-out 0s infinite running ${spin};
    border-radius: 50%;
    border: 2px solid gray;
    border-bottom-color: transparent;
  }

  :disabled {
    opacity: .5;
    color: transparent;
    ::after {
      display: block;
    }
  }

  ${media.md`

  `}
`;

const SocialLoginButton = styled(AuthButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ::before {
    content: '';
    width: 24px;
    height: 24px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 10px;
    position: absolute;
    left: 28px;
  }

`;

export const GoogleLoginButton = styled(SocialLoginButton)`
  border: 1px solid ${theme.color.disabled};
  background-color: ${theme.color.white};
  color: ${theme.color.black};

  ::before {
    background-image: url('/assets/images/auth/google.png');
  }
`;

export const FacebookLoginButton = styled(SocialLoginButton)`
  background-color: #4167B2;
  color: ${theme.color.white};

  ::before {
    background-image: url('/assets/images/auth/facebook.png');
  }
`;

// 새로 생성
export const RoundButton = styled.button`
  box-sizing: border-box;
  padding: 14px 23px;
  border: 1px solid white;
  border-radius: 27px;
  background: none;
  display: flex;
  align-items: center;
  cursor: pointer;

  justify-content: center;
  font-family:  ${theme.fontFamily.regular};
  font-size: 13px;
  line-height: 16px;

  &:hover {
    border: 1px solid ${theme.color.border};
    box-shadow: 10px 10px 30px rgba(84, 100, 224, 0.1);
  }

  ${media.lg`
    >div {
      display: none;
    }
    &.test{
      display: none;
    }
    padding: 0;
    width: 46px;
    height: 46px;
    border: 1px solid #c3c9f8;
  `}

  ${media.xl`
    padding: 14px 13px;
  `}
`;

export const ButtonLogo = styled.img`
  margin-right: 12px;
  width: 23px;
  height: 23px;
  ${media.xl`
   margin-right: 9px;
  `}
  ${media.lg`
    margin-right: 0;
  `}
  ${media.xs`
    width: 21px;
    height: 21px;
  `}
`;
